<template>
  <div id="app">
      <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'appHeader',
  methods: {
    name() { }
  },
  created () {
    console.log(222);
  },
};
</script>
